import { Campaign } from '@markant-platform/campaign/model';
import { signal } from '@angular/core';

export class MockRegistrationStore {
  // Signals are replaced by WritableSignals
  isLoading = signal(false);
  campaign = signal<Campaign | null>(null);
  isRegistrationSuccess = signal(false);
  termsOfUseLink = signal('');
  serviceConditionsLink = signal('');
  privacyPolicyLink = signal('');
  serviceGTCLink = signal('');

  // RxMethods
  getCampaign(): void {
    return;
  }
  getServiceConditions(): void {
    return;
  }

  registerCampaignCustomer(): void {
    return;
  }

  getServiceGTCLink(): void {
    return;
  }

  getPrivacyPolicyLink(): void {
    return;
  }

  getTermsOfUseLink(): void {
    return;
  }
}
